import {
  getStoredSiderWidth as coreGetStoredSiderWidth,
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
  SiderResizeHandle,
} from '@zhiyue/core';

export const DEFAULT_SIDER_WIDTH = 208;

export const getStoredSiderWidth = (): number => {
  const width = coreGetStoredSiderWidth();
  return typeof width === 'number' && width >= 180 && width <= 260
    ? width
    : DEFAULT_SIDER_WIDTH;
};

export { MAX_SIDER_WIDTH, MIN_SIDER_WIDTH, SIDER_WIDTH_STORAGE_KEY };

export default SiderResizeHandle;
